import { createPhoneStandingConsentsService } from '@shared/api'
import { authorizedHttpClient } from './http-client'

export const PhoneStandingConsentsService = createPhoneStandingConsentsService(
  authorizedHttpClient,
  import.meta.env.VITE_API_URL,
)
